export const duplicateEventTypes = {
  'api.crud.insert.contact': true,
  'event.custom.submit.contact': true,
  'event.sms.twilio.inbound': true,
}

export const duplicateEventTypeIDs = {
  12: 'B',
  13: 'C',
  15: 'B',
  17: 'B',
  18: 'C',
}

export const eventGoalOptionsMapFunc = eventgoaloptions =>
  Object.values(eventgoaloptions || {}).reduce((acc, option) => {
    if (duplicateEventTypeIDs?.[option?.id]) {
      acc[`${option.event_type}${duplicateEventTypeIDs?.[option?.id]}`] = option
    } else {
      acc[option.event_type] = option
    }
    return acc
  }, {})

export const trueEventOptionFunc = (event_goal, eventgoaloptions) => {
  const eventGoalOptionsMap = eventGoalOptionsMapFunc(eventgoaloptions)

  if (event_goal && Object.keys(eventGoalOptionsMap || {})?.length) {
    let trueEventOption = eventGoalOptionsMap[event_goal?.event_type]

    if (!event_goal?.event_type || !trueEventOption) return null

    if (duplicateEventTypes?.[event_goal?.event_type]) {
      if (event_goal.event_type === 'api.crud.insert.contact') {
        if (event_goal.subentity_value) {
          trueEventOption = eventGoalOptionsMap['api.crud.insert.contactB']
        }
      }

      if (event_goal.event_type === 'event.custom.submit.contact') {
        if (event_goal.subentity_value) {
          trueEventOption = eventGoalOptionsMap['event.custom.submit.contactC']
        } else if (event_goal.subentity) {
          trueEventOption = eventGoalOptionsMap['event.custom.submit.contactB']
        }
      }

      if (event_goal.event_type === 'event.sms.twilio.inbound') {
        if (event_goal.subentity) {
          trueEventOption = eventGoalOptionsMap['event.sms.twilio.inboundC']
        } else if (event_goal.entity) {
          trueEventOption = eventGoalOptionsMap['event.sms.twilio.inboundB']
        }
      }
    }

    return trueEventOption
  }

  return null
}

// export default {
//   'api.association.associate.contact':
// }
